import React, {Component} from 'react';
import Link from 'gatsby-link'
import styled from 'styled-components';
import {NavLink} from "../Kit/Kit";
import {Dropdown} from "../Dropdown/Dropdown";

const Container = styled.div`
  display: none;
  
  @media(min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(5, auto);
    grid-column-gap: 26px;
    align-items: center;
    height: 100%;
  }
  
  i {
    margin-bottom: 10px;
    height: 100%;
  }
  
  .main-nav-item {
      text-decoration: none;
      font-family: Cabin-Bold, sans-serif;
      color: #737373;
      font-size: 12px;
      text-transform: uppercase;
      cursor: pointer;
      position: relative;
      border-bottom: 3px solid white;
      z-index: 1;
      
      @media(min-width: 992px){
        font-size: 14px;
      }
      
      @media(min-width: 1200px){
        font-size: 16px;
      }
      
      @media(min-width: 1680px) {
        font-size: 19px;
      }
  }
  
  .active{
      font-family: Cabin-Bold, sans-serif;
      color: #004a87;
      font-size: 12px;
      text-transform: uppercase;
      cursor: pointer;
      border-bottom: 3px solid #004a87;
      line-height: 1.5;
      
      @media(min-width: 992px){
        font-size: 16px;
      }
      
      @media(min-width: 1680px) {
        font-size: 19px;
      }
  }
`;

const LinkContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 1.5;
  
   :hover {
      .main-nav-item {
          color: #004a87;
          outline: none;
          border-bottom: 3px solid #004a87;
          line-height: 1.5;
      }
   }
`;

const GetToKnowLinks = [
    {title: 'Our Story', link: '/get-to-know#ourstory', titleseo:"About H & N Group"},
    {title: `Mr. Ngo's Story`, link: '/get-to-know#mrngosstory', titleseo:"Hua Ngo's Story"},
    {title: `Management Team`, link: '/get-to-know#team', titleseo:"H & N Group Management Team"},
];

class DesktopMenu extends Component {
    state = {
        gtkMenuOpen: false,
        productMenuOpen: false,
        connectMenuOpen: false
    };

    handleMouseEnter = (menu) => {
        if (menu === 'gtk') {
            this.setState({
                gtkMenuOpen: true,
            })
        } else if (menu === 'product') {
            this.setState({
                productMenuOpen: true,
            })
        } else {
            this.setState({
                connectMenuOpen: true
            })
        }
    };

    handleMouseLeave = () => {
        this.setState({
            gtkMenuOpen: false,
            productMenuOpen: false,
            connectMenuOpen: false
        })
    };

    handleClick = () => {
        this.setState({
            gtkMenuOpen: false,
            productMenuOpen: false,
            connectMenuOpen: false
        })
    };

    render() {
        const {gtkMenuOpen, productMenuOpen, connectMenuOpen} = this.state;
        const Product = this.props.slug.map(i => {
            const {slug, acf: {title}} = i.node;
            const titleseo = `H & N Group Wholesale ${title}`;
            return (
              {slug, title, titleseo}
            )
        });
        const ProductDropdown = [{slug: 'product-info', title: 'All', titleseo: 'View H & N Group Wholesale Products'}, ...Product];
        const {jobOpening} = this.props;
        return (
          <Container>
              <LinkContainer
                onMouseEnter={() => this.handleMouseEnter('gtk')}
                onMouseLeave={() => this.handleMouseLeave()}
              >
                  <Link
                    to="/get-to-know"
                    title="Get to Know H & N Group"
                    activeClassName="active"
                    className="main-nav-item"
                    onClick={() => this.handleClick()}
                  >
                      Get to know H & N
                  </Link>
                  <Dropdown isOpen={gtkMenuOpen}>
                      {GetToKnowLinks.map(i => {
                          return <NavLink key={i.title} to={i.link} title={i.titleseo}>{i.title}</NavLink>
                      })}
                  </Dropdown>
              </LinkContainer>
              <LinkContainer
                onMouseEnter={() => this.handleMouseEnter('product')}
                onMouseLeave={() => this.handleMouseLeave()}
              >
                  <Link
                    to="/product-info"
                    title="H & N Group Wholesale Products"
                    onClick={() => this.handleClick()}
                    activeClassName="active"
                    className="main-nav-item"
                  >
                      Product Info
                  </Link>
                  <Dropdown isOpen={productMenuOpen}>
                      {ProductDropdown.map(i => {
                          return <NavLink key={i.title} to={`/${i.slug}`} title={i.titleseo}>{i.title}</NavLink>
                      })}
                  </Dropdown>
              </LinkContainer>
              <LinkContainer>
                  <Link
                    to="/affiliations"
                    title="H & N Group Affiliates"
                    activeClassName="active"
                    className="main-nav-item"
                    onClick={() => this.handleClick()}
                  >
                      Affiliations
                  </Link>
              </LinkContainer>
              <LinkContainer
                onMouseEnter={() => this.handleMouseEnter('connect')}
                onMouseLeave={() => this.handleMouseLeave()}
              >
                  <Link
                    to="/connect"
                    title="Get In Touch with H & N Group"
                    activeClassName="active"
                    className="main-nav-item"
                    onClick={() => this.handleClick()}
                  >
                      Connect
                  </Link>
                  <Dropdown isOpen={connectMenuOpen}>
                      <NavLink to="/connect" title="H & N Group's 3 Locations">
                          Our Locations
                      </NavLink>
                      {jobOpening ?
                        <NavLink to="/join-our-team" title="Join the H & N Group Team">
                            Join Our Team
                        </NavLink> :
                        ''
                      }
                  </Dropdown>
              </LinkContainer>
              <a href="https://www.linkedin.com/company/7953704/" title="Follow H & N Group on LinkedIn" target="_blank">
                  <i
                    className="fab fa-linkedin fa-2x"
                    style={{color: '#255e94'}}
                  />
              </a>
          </Container>
        );
    }
}

export default DesktopMenu;


// WEBPACK FOOTER //
// ./src/components/NavBar/DesktopMenu.js